/**
 * The level a child sees. It's a share of all the stars on offer, so adding a
 * game lowers it for everyone, though nobody lost a star (Stepping Stones
 * reaching every community would have taken a child at level 70 to about 65).
 * So a child's level never goes down: the best they've reached is kept, and
 * clearing their data clears that too.
 */

/** The level for a percentage of all stars: the highest one reached. */
export const levelFor = (percentage, levels) => {
  let level = 0;
  for (const d of levels) {
    if (d.Progress > percentage) break;
    level = d.Level;
  }
  return level;
};

/** The level for a count of stars. */
export const levelForStars = (currentStars, totalStars, levels) =>
  totalStars > 0 ? levelFor((currentStars / totalStars) * 100, levels) : 0;

/**
 * The lowest a returning child's level may be: their saved best, or the level
 * their saved progress already earned. That second one matters the first time
 * a new game arrives: progress saved before it doesn't count it yet.
 * No saved progress means a new or cleared player, who starts from nothing.
 */
export const levelFloor = ({ savedBest, savedStars, levels }) => {
  if (!savedStars) return 0;
  return Math.max(Number(savedBest) || 0, levelForStars(savedStars.currentStars, savedStars.totalStars, levels));
};
